import { useGetRequiredRule } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { FeedsFormFieldsNames } from '../helpers/types';

export const useFeedsFormRules = (isEdit: boolean) => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });

  return {
    ...(isEdit && { [FeedsFormFieldsNames.SLUG]: [requiredRule] }),
    [FeedsFormFieldsNames.CATEGORIES]: [requiredRule],
    [FeedsFormFieldsNames.REGION_ID]: [requiredRule],
    [FeedsFormFieldsNames.ACTIVE]: [requiredRule],
    [FeedsFormFieldsNames.NAME]: [requiredRule],
  };
};
